export const RepresentanteBuscaEntity = {
    codconsultor: 0
    ,codparc:0
    ,nomeparc: ""
    ,dtinicial: null
    ,dtfinal: new Date()
    ,codcid:0
    ,palavra:""
}